module.exports = __webpack_public_path__ + "media/images/mycode-d1635c9812752ce217fd7729136cce1b.png";